var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowSmallRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 12,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4A90E2",
    fillRule: "evenodd",
    d: "M9.05 11.9a.997.997 0 00.708-.294l4.949-4.95a.002.002 0 00.002-.002c0-.002.003-.003.003-.002 0 0 0-.002.002-.002 0-.002.003-.003.003-.003.002 0 .002-.003.002-.002 0 0 0-.002.002-.002a.002.002 0 00.002-.003l.003-.002s0-.002.002-.003l.002-.002a.987.987 0 00.195-.303v-.002a.977.977 0 00.075-.36v-.036a1.007 1.007 0 00-.074-.362h-.001a.987.987 0 00-.195-.304l-.002-.003c-.001 0-.002 0-.002-.002l-.003-.003-.002-.002-.002-.002-.002-.002s-.003.006-.002-.002h-.001l-.002-.003s-.008.002-.002-.002h-.001l-.002-.003L9.757.293a.999.999 0 10-1.413 1.414l3.242 3.242H1a1 1 0 100 2h10.586l-3.242 3.243A.999.999 0 009.05 11.9"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSmallRight);
export default __webpack_public_path__ + "static/media/arrow-small-right.e17986e7307293dc2dbe231b57ad775c.svg";
export { ForwardRef as ReactComponent };